import { z } from "zod";

// Run before importing app schemas: Zod's JIT capability probe uses Function,
// which strict CSP blocks even when the caught error falls back successfully.
z.config({ jitless: true });
